
    import React from 'react';
    import ReactDOM from 'react-dom';
    import { withStyles } from '@wix/native-components-infra';
    import EditorAppWrapper from '@wix/yoshi-flow-editor/runtime/esm/EditorAppWrapper.js';
    import Widget from '/home/builduser/work/9b222164c6be38e0/packages/communities-forum-client/src/components/RecentPostsFeed/Widget/index.tsx';
    import createController from '/home/builduser/work/9b222164c6be38e0/packages/communities-forum-client/src/components/RecentPostsFeed/controller.ts';

    
var createHttpClient = null;

    
var initI18n = null;

    
import { createExperiments, createWidgetExperiments } from '@wix/yoshi-flow-editor/runtime/esm/experiments';
    

    

    var createErrorMonitor = null;
    

    
var I18nextProvider = React.Fragment;


      import { PureExperimentsProvider } from '@wix/wix-experiments-react';
      var ExperimentsProvider = React.Fragment;
      

import { BILoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/BILogger/BILoggerProvider';

var FedopsLoggerProvider = React.Fragment;

var HttpProvider = React.Fragment;

var providers = {
  I18nextProvider,
  ExperimentsProvider,
  PureExperimentsProvider,
  BILoggerProvider,
  FedopsLoggerProvider,
  HttpProvider,
}

    var fedopsLogger = null;

    
  import * as viewerApp from '/home/builduser/work/9b222164c6be38e0/packages/communities-forum-client/src/viewer.app.ts';
    var importedApp = viewerApp;

    var componentName = 'RecentPostsFeed';
    var projectName = 'communities-forum-client';
    var sentryConfig = {
      DSN: 'https://baf30a2b91654c5a840931f0137bed30@sentry.wixpress.com/1696',
      id: 'baf30a2b91654c5a840931f0137bed30',
      projectName: 'communities-forum-client',
      teamName: 'forum',
      
    };
    var stylesParams = null;
    var experimentsConfig = {"scopes":["wix-forum"]};
    var translationsConfig = {"enabled":false,"icuEnabled":false};
    var defaultTranslations = null;
    var biConfig = null;
    var appDefinitionId = "14724f35-6794-cd1a-0244-25fd138f9242";
    var componentId = "151bd179-dfe6-3ca3-399c-ee97957f93a2";
    var localeDistPath = 'assets/locales';
    var shouldUseEssentials = false;
    var shouldSkipMultipleRendersAfterViewModeChange = false;
    var withErrorBoundary = true;

    import { createVisitorBILogger as biLogger } from '/home/builduser/work/9b222164c6be38e0/packages/communities-forum-client/target/generated/bi/createBILogger.ts';
    
      import { hot } from '@wix/component-hot-loader';
      var UserComponent = hot(module, Widget);
    

    var EditorComponent = React.createElement(EditorAppWrapper, {
      UserComponent,
      appDefinitionId,
      componentId,
      name: componentName,
      sentryConfig: sentryConfig,
      experimentsConfig: experimentsConfig,
      translationsConfig: translationsConfig,
      defaultTranslations: defaultTranslations,
      shouldUseEssentials,
      projectName: projectName,
      biConfig: biConfig,
      biLogger: biLogger,
      stylesParams,
      withErrorBoundary,
      shouldSkipMultipleRendersAfterViewModeChange,
      userController: createController,
      customInitAppForPage: importedApp.initAppForPage,
      optionalDeps: {
        initI18n,
        fedopsLogger,
        withStylesHoc: withStyles,
        createHttpClient,
        createExperiments,
        createWidgetExperiments,
        createErrorMonitor,
        providers,
      },
      localeDistPath: localeDistPath,
    });
    ReactDOM.render(EditorComponent, document.getElementById('root'));
